<template>
  <div id="manager">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="文本查询">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="formInline.PhoneNumber"
            class="input-with-select"
          >
            <el-button
              @click="handleCurrentChange(1)"
              slot="append"
              icon="el-icon-search"
            >
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          label-width="0px"
        >
          <el-button
            type="primary"
            @click="dialogVisible = true"
          >
            新增
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="managerList"
        border
        style="width: 100%"
      >
        <el-table-column header-align="center" align="center" prop="name" label="用户名 "/>
        <el-table-column header-align="center" align="center" prop="phoneNumber" label="手机号 "/>
        <el-table-column header-align="center" align="center" prop="department" label="部门 "/>
        <el-table-column header-align="center" align="center" label="创建时间">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.createTime ? scope.row.createTime.slice(0, 10) : ''}}</span> -->
            <span>{{ scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rolePermissions" label="角色权限" header-align="center" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.rolePermissions && Array.isArray(row.rolePermissions) && row.rolePermissions.length > 0">
              <div
                style="display:inline-block;padding: 3px 5px;margin: 3px;background-color: #e9e9eb;color: #909399;border-radius: 5px;"
                v-for="(item, index) in row.rolePermissions"
                :key="index">
                {{ item.roleName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isDeveloper" label="发展专员设置" header-align="center" align="center">
          <template slot-scope="{row, $index}">
            <el-switch
              v-model="row.isDeveloper"
              :active-value="true"
              :inactive-value="false"
              active-color="#049EA3"
              inactive-color="#909399"
              @change="changeDeveloper(row, $index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="isReciveTransferMessage" label="接收转账失败提醒" header-align="center" align="center">
          <template slot-scope="{row, $index}">
            <el-switch
              v-model="row.isReciveTransferMessage"
              :active-value="true"
              :inactive-value="false"
              active-color="#049EA3"
              inactive-color="#909399"
              @change="changeSwitch(row, $index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              @click="auth(scope.row)"
              size="mini"
              plain
            >
              设置权限
            </el-button>
            <el-button
              @click="deleteM(scope.row)"
              type="danger"
              size="mini"
              plain
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加管理员"
      :visible.sync="dialogVisible"
      :before-close="close"
      width="35%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        :rules="addRules"
      >
        <el-form-item
          label="手机号"
          label-width="120px"
          prop="phoneNumber"
          :rules="[{ required: true,validator: phone, trigger: 'blur' }]"
        >
          <el-input
            v-model="addForm.phoneNumber"
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          label-width="120px"
          prop="name"
          :rules="[{ trigger: 'blur' }]"
        >
          <el-input
            v-model="addForm.name"
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="部门"
          label-width="120px"
          prop="department"
          :rules="[{ trigger: 'blur' }]"
        >
          <el-input
            v-model="addForm.department"
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="是否为发展专员"
          label-width="120px"
          prop="isDeveloper"
        >
          <el-switch
            v-model="addForm.isDeveloper"
            :active-value="true"
            :inactive-value="false"
            active-color="#049EA3"
            inactive-color="#909399"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancle">取 消</el-button>
        <el-button
          type="primary"
          @click="addManager"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <authDialog ref="authDialog" @done="getManagerList"/>
  </div>
</template>

<script>
  import {getAdministration, addAdministration2 as add, deleteAdmin, setTransferTip, setDeveloper} from 'api/request'
  import {SetTableH} from '../../utils/utils'
  import authDialog from "../members/components/authDialog";

  export default {
    data() {
      return {
        tableH: '250',
        loading: true,
        addForm: {
          phoneNumber: '',
          name: '',
          department: '',
          isDeveloper: false,
        },
        formInline: {
          PhoneNumber: ''
        },
        addRules: {},
        pageObj: {
          total: 0,
          PageIndex: 1,
          PageSize: 10
        },
        managerList: [],
        dialogVisible: false
      }
    },
    components: {authDialog},
    methods: {
      handleSizeChange(val) {
        this.pageObj.PageSize = val
        this.getManagerList()
      },
      handleCurrentChange(val) {
        this.pageObj.PageIndex = val
        this.getManagerList()
      },
      async getManagerList() {
        let params = {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          PhoneNumber: this.formInline.PhoneNumber
        }
        this.loading = true
        let data = await getAdministration(params)
        if (data) {
          this.managerList = data.rows
          this.pageObj.total = data.total
          this.loading = false
        }
      },
      async addManager() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            let params = {
              phoneNumber: this.addForm.phoneNumber,
              name: this.addForm.name,
              department: this.addForm.department,
              isDeveloper: this.addForm.isDeveloper,
            }
            add(params).then(data => {
              if (data) {
                this.dialogVisible = false
                this.addForm.phoneNumber = ''
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.getManagerList()
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      async deleteM(item) {
        this.$confirm(
          `是否确定删除手机号为${item.phoneNumber}的管理员?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          deleteAdmin(item.id).then(data => {
            if (data) {
              this.$message({
                message: '已成功删除',
                type: 'warning'
              })
              this.getManagerList()
            }
          })
        }).catch(() => {})
      },
      async changeSwitch(row, index) {
        setTransferTip({id: row.id}).then(data => {
          if (data) {
            this.$message({message: '设置成功', type: 'success'})
            this.$set(row, 'isReciveTransferMessage', row.isReciveTransferMessage)
            this.$set(this.managerList, index, row)
          } else {
            this.$message({message: '设置失败', type: 'warning'})
            this.$set(row, 'isReciveTransferMessage', !row.isReciveTransferMessage)
            this.$set(this.managerList, index, row)
          }
        })
      },
      async changeDeveloper(row, index) {
        setDeveloper({adminId: row.id}).then(data => {
          if (data) {
            this.$message({message: '设置成功', type: 'success'})
            this.$set(row, 'isDeveloper', row.isDeveloper)
            this.$set(this.managerList, index, row)
          } else {
            this.$message({message: '设置失败', type: 'warning'})
            this.$set(row, 'isDeveloper', !row.isDeveloper)
            this.$set(this.managerList, index, row)
          }
        })
      },
      cancle() {
        this.$refs['addForm'].resetFields()
        this.dialogVisible = false
      },
      close() {
        this.$refs['addForm'].resetFields()
        this.dialogVisible = false
      },
      /**
       * 手机校验
       */
      phone(rule, value, callback) {
        let rep = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
        const rs = rep.test(value)
        if (!rs && value) {
          callback(new Error('请输入正确手机号码'))
        } else {
          callback()
        }
      },
      auth(data) {
        let temData = JSON.parse(JSON.stringify(data))
        temData.phone = data.phoneNumber
        temData.type = 1
        this.$refs.authDialog.show(temData)
      }
    },
    mounted() {
      SetTableH(this)
    },
    created() {
      this.getManagerList()
    }
  }
</script>
<style lang='scss'>
  #manager {
    height: 100%;
    width: 100%;
    
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
